import { getWeeksFromNow } from "../../../../../common-deprecated/utils";
import { type BuildAndBuyStateType, useBnbSelector } from "../../redux/store";
import { getBnbLabel, useBnbOptionalLabel } from "../../utils/labels";

type ETADeliveryLabelParams = {
    state: BuildAndBuyStateType;
    maxNumberOfWeeks: false | RegExpMatchArray | null;
    deliverySingleWeekLabel: string;
    noDeliveryLabel: string | null;
    weeksFromNow?: number | false | "";
    date?: string | false;
};
const getLabel = ({
    maxNumberOfWeeks,
    deliverySingleWeekLabel,
    noDeliveryLabel,
    weeksFromNow,
    date,
    state,
}: ETADeliveryLabelParams): string | null => {
    // checking for 19000101 is a specific request. This is used as a fallback when production restrictions are full for the next 3 months.(OR-2081)
    if (weeksFromNow && date !== "19000101") {
        if (maxNumberOfWeeks && !Number.isNaN(+maxNumberOfWeeks[3]) && weeksFromNow > +maxNumberOfWeeks[3]) {
            return getBnbLabel(state, "deliveryExceededNumberOfWeeks", {
                weeks: weeksFromNow,
                [maxNumberOfWeeks[1]]: "",
            });
        } else if (weeksFromNow <= 1) {
            return deliverySingleWeekLabel;
        } else {
            return getBnbLabel(state, "deliveryWeeks", {
                weeks: weeksFromNow,
            });
        }
    } else if (noDeliveryLabel) {
        return noDeliveryLabel;
    } else if (!date) {
        return null;
    }
    return deliverySingleWeekLabel;
};

const useETADeliveryLabel = (date?: string | false): string | null => {
    const state = useBnbSelector((bnbState) => bnbState);
    const deliverySingleWeekLabel = getBnbLabel(state, "deliverySingleWeek");
    const [maxNumberOfWeeksLabel, noDeliveryLabel] = useBnbOptionalLabel([
        "deliveryExceededNumberOfWeeks",
        "noDelivery",
    ]);
    const maxNumberOfWeeks = maxNumberOfWeeksLabel ? maxNumberOfWeeksLabel.match(/{((maxWeeks)(\d*))}/i) : false;

    const weeksFromNow =
        date &&
        getWeeksFromNow(
            new Date(parseInt(date.substr(0, 4)), parseInt(date.substr(4, 2)) - 1, parseInt(date.substr(6, 2))),
        );

    return getLabel({ weeksFromNow, deliverySingleWeekLabel, maxNumberOfWeeks, noDeliveryLabel, state, date });
};

export default useETADeliveryLabel;
